import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import { Typography } from '@/components/Typography';
import * as OM from '@/messages/order';
import * as PM from '@/messages/payment';

import { useOrderDetailsContext } from '../OrderDetailsContext';

import * as S from '../OrderDetailsView.styles';

export function OrderReminderSection() {
  const ctx = useOrderDetailsContext();
  const isVisible = Boolean(
    ctx.payPerLinkToken || ctx.isPayPerLinkTokenLoading,
  );

  if (!isVisible) return null;

  return (
    <S.ReminderBox backgroundColor='primaryDark' p={2}>
      <Flex
        alignItems='center'
        flexWrap='wrap'
        gridGap={1}
        justifyContent='space-between'
      >
        <Box>
          <Flex alignItems='center'>
            <S.ReminderIcon />
            <Typography color='white'>{OM.OrderReminder}</Typography>
          </Flex>
        </Box>
        <Box width={ctx.isMobileView ? '100%' : ''}>
          <S.BalanceButton
            disabled={Boolean(ctx.isPayPerLinkTokenLoading)}
            isProcessing={Boolean(ctx.isPayPerLinkTokenLoading)}
            onClick={() =>
              ctx.payPerLinkToken &&
              ctx.push(
                ctx.paths.store.order.payment.url({
                  token: ctx.payPerLinkToken,
                }),
              )
            }
          >
            {ctx.formatMessage(PM.paymentMessages.payTheBalance)}
          </S.BalanceButton>
        </Box>
      </Flex>
    </S.ReminderBox>
  );
}
